import React, { useEffect } from 'react';
import Styles from './Popup.module.scss';
import { useTranslation } from 'react-i18next';

import Cross from '../../../../../assets/Cross';
import infoIcon from '../../../../../assets/infoIconGrayBG.svg'
type Props = {
    showToast: boolean;
    setShowToast: (value: boolean) => void;
    dropDown: boolean;
}

const ToastPopup = (props: Props) => {

    const { showToast, setShowToast } = props;
    const { t } = useTranslation();

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowToast(false);
        }, 3000);
        return () => {
            setShowToast(true);
            clearTimeout(timer);
        }
    }, []);

    return (
        <div
            className={Styles.popUp}
            style={{ display: showToast ? "flex" : "none" }}>
            <img
                src={infoIcon}
                alt='alert'
                className={Styles.img}
            />
            <div className={Styles.text}>
                {t("KLR02701")}
            </div>
            <div className={Styles.cross}>
                <Cross
                    height={24}
                    width={24}
                    color={'#C3CDD9'}
                    onClick={() => setShowToast(false)}
                    cursor='pointer'
                />
            </div>
        </div>
    )
}

export default ToastPopup;